<template>
    <div class="page-scan-out">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">澳門倉庫</div>
            <div class="breadcrumb-item">掃描入庫</div>
        </div>

        <div class="card-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Form :label-width="150">
                    <Row>
                        <Col span="11" push="6">
                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>入庫袋號</span>
                                </div>
                                <Input v-model="form.sack_number" ref='macao_scanin_id' @keyup.enter.native="handleCheckFrom"/>
                            </FormItem>

                            <FormItem>
                                <div class="pg-btn-wrap pg-form-btn">
                                    <div class="pg-btn style1" @click="handleCheckFrom">入庫</div>
                                </div>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>

            <Table size="small"
                   border
                   no-data-text="暫無數據"
                   :columns="table.column"
                   :data="table.data">
                <template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style1" @click="handleDelete(index)">移出</div>
                    </div>
                </template>
            </Table>

        </div>
    </div>
    </div>
</template>

<script>
    export default {
        data()
        {
            return {
				err_audio: "https://jyb-admin-backend.aoyunltd.com/audio/music-fail.mp3",
				suc_audio: "https://jyb-admin-backend.aoyunltd.com/audio/music-success.mp3",
                form: {
                    sack_number: '',
                },
                isSubmiting: false,
                table: {
                    column: [
                        {
                            title: '序號',
                            key: 'id',
                            align: 'center',
							sortable: true,
                            minWidth: 70,
                            //sortable: true
                        },
                        {
                            title: '入庫袋號',
                            key: 'sack_number',
                            align: 'center',
							sortable: true,
                        },
                        {
                            title: '入庫時間',
                            key: 'macao_originating_time',
                            align: 'center',
							sortable: true,
                        },
                        {
                            title: '操作人',
                            key: 'actor',
                            align: 'center',
							sortable: true,
                            //slot: 'action',
                            minWidth: 100
                        }
                    ],
                    data: []
                }
            };
        },
        computed: {
            logInfo()
            {
                return this.$store.state.logInfo;
            }
        },
        methods: {
            //根據袋號獲取訂單列表
            handleSearch()
            {
                if (this.form.sack_number === '')
                {
                    this.table.data = [];
                    return;
                }
                this.getOrderBySackNo(this.form.sack_number);
            },

            handleCheckFrom()
            {
                let form = this.form;
                if (form.sack_number === '')
                {
                    this.$Utils.showTipInfo('請輸入入庫袋號');
                    return;
                }

                this.handleSubmit();
				this.$refs.macao_scanin_id.focus();
				this.form.sack_number= '';
            },

            handleSubmit()
            {
                let form = this.form;
                this.isSubmiting = true;

                this.$Rq.requestAuth({
                    url: this.$Api.macaoScanIn,
                    method: 'post',
                    data: {
                        sack_number: form.sack_number,
                        macao_originating: 1  //0 是珠海仓，1是澳门已入库，2是澳门已出库
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;

                    if (res.code == 0)
                    {
                        this.$Utils.showSuccess(res.msg);
                        let tempArr = this.table.data;
                        tempArr.push({
                            id: this.table.data.length,
                            sack_number: res.data.sack_number,
                            macao_originating_time: res.data.macao_originating_time,  //澳门仓库入库时间
                            // macao_originating_out_time: resData[i].macao_originating_out_time,  //澳门出库时间
                            actor: this.logInfo.username
                        });
                        this.table.data = tempArr;

                        this.form = {
                            sack_number: ''
                        };
						let audio = new Audio()
						audio.src = this.suc_audio
						audio.play();
                    } else {
                        this.$Utils.showTipInfo(res.msg);
						let audio = new Audio()
						audio.src = this.err_audio
						audio.play();
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
					let audio = new Audio()
					audio.src = this.err_audio
					audio.play();
                });
            },

            handleDelete(index)
            {
                this.$Modal.confirm({
                    title: '提示',
                    content: '確定移出嗎？',
                    cancelText: '取消',
                    okText: '確定',
                    onOk: () =>
                    {
                        let tableData = this.table.data;
                        this.isSubmiting = true;

                        this.$Rq.requestAuth({
                            url: this.$Api.delSack,
                            method: 'post',
                            data: {
                                id: tableData[index].id
                            }
                        }).then((res) =>
                        {
                            this.isSubmiting = false;

                            if (res.code == 0)
                            {
                                this.$Utils.showSuccess(res.msg);

                                if (tableData.length <= 1 && this.pageIndex > 1)
                                {
                                    this.pageIndex -= 1;
                                }
                                this.getOrderBySackNo();

                            } else
                            {
                                this.$Utils.showTipInfo(res.msg);
                            }
                        }).catch((err) =>
                        {
                            this.isSubmiting = false;
                        });
                    }
                });
            },

            //pager
            handlePageSizeChange(value)
            {
                this.pageIndex = 1;
                this.getOrderBySackNo();
            },

            handlePageInput()
            {
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.ceil(this.totalCount / this.curPageSize);
                if (value > pageCount)
                {
                    value = pageCount;
                }
                this.pageInput = value;
            },
            handlePageEnter()
            {
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0)
                {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
                this.getOrderBySackNo();
            },

            handlePageChange(value)
            {
                this.pageIndex = value;
                this.getOrderBySackNo();
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "ScanIn";
</style>